/**
 * Base URL for public visitor traffic: published site JSON (`/api/...`) and form POSTs (`/forms/...`).
 * When `VITE_API_BASE_URL` is unset, returns '' so requests stay same-origin (Vercel rewrites, local Vite proxy).
 * Authenticated API calls should continue using `API_BASE_URL` from `src/api/core.ts`.
 */
export function getPublicApiBaseUrl(): string {
  return (import.meta.env.VITE_API_BASE_URL || '').trim().replace(/\/$/, '');
}
